import Services from "../../services/Services";
const services = new Services(null) as any;

// toast actions
import {
  dismiss,
  update,
  error,
  message,
  warning,
  success,
  info,
} from "react-toastify-redux";

const TOGGLE_LOADERS = "teacherPerceptions/toggleLoaders";
const GET_PERCEPTIONS = "teacherPerceptions/getPerceptions";
const GET_COHORTS_DATA = "teacherPerceptions/getCohorts";
const GET_COHORTS_PERCEPTIONS_DATA = "teacherPerceptions/getCohortsPerceptionData"
const GET_COHORT_PERCEPTIONS = "teacherPerceptions/getCohortsPerceptions";
const UPDATE_MULTIPLE_VALS = "teacherPerceptions/updateMultipleVals"


const INITIAL_STATE = {
    // departments: [],
    // yearGroups: [],
    cohorts: [],
    cohortsLoaded: false,
    perceptionsList: [],
    perceptionsData: null,
    selectedPerception: null,
    cohortID: null,
    studentCount: null,
    perceptionsListLoaded: false,
    perceptionsDataLoaded: false,
    currentUserType: "",
    isLoading: false,
    firstClickDone: false
}

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;

    switch(type) {
        // case GET_YEARGROUPS_DEPARTMENTS:
        //     return {
        //         ...state,
                
        //     }
        case GET_PERCEPTIONS: 
            return {
                ...state,
                perceptionsList: payload.perceptionsList,
                perceptionsListLoaded: payload.loaded
            };
        
        case GET_COHORTS_DATA: 
            return {
                ...state,
                cohorts: payload.cohorts,
                cohortsLoaded: payload.cohortsLoaded,
                currentUserType: payload.userType
            };

        case GET_COHORT_PERCEPTIONS: 
        return {
            ...state,
            perceptionsData: payload
        };

        case GET_COHORTS_PERCEPTIONS_DATA: {
            return {
                ...state,
                ...payload
            }
        }

        case TOGGLE_LOADERS: 
            return {
                ...state,
                ...payload
            };

            case UPDATE_MULTIPLE_VALS: {
                return {
                    ...state,
                    ...payload
                }
            }

        default: return state;
    }
}

export const getPerceptions = () => async (dispatch) => {
    const res = await services.adminAPI.getPerceptions();
    const perceptionsList = res.data.perceptions;
    dispatch({type: GET_PERCEPTIONS, payload: {perceptionsList, loaded: true}});
}

export const getCohorts = () => async (dispatch) => {
    const res = await services.teachersAPI.getGlobalCohortsList();
    console.log({res});
    if(res.ok) {
        dispatch({type: GET_COHORTS_DATA, payload: {cohorts: res.data.cohorts, cohortsLoaded: true}})
    }else {
        dispatch(error("Unable to fetch your cohorts"));
    }

}

export const getCohortsPerceptionData = (cohortID, perceptionID) => async (dispatch) => {
     const perceptionsRes =
      await services.teachersAPI.getCohortPerceptionStudents(
        cohortID,
        perceptionID
      );

      console.log({perceptionsRes})
    if (perceptionsRes.ok) {
      dispatch({type: GET_COHORTS_PERCEPTIONS_DATA , payload: {
        perceptionsData: perceptionsRes.data.users,
        perceptionsDataLoaded: true,
        isLoading: false,
      }});
    }
}

export const toggleLoaders = (loaderObject) => async (dispatch) => {
// pass an object with the loader you'd like to change
    dispatch({type: 'TOGGLE_LOADERS', payload: loaderObject})
}

export const updateMultipleVals = (valuesObj) => async (dispatch) => {
    dispatch({type: UPDATE_MULTIPLE_VALS, payload: valuesObj});
}





// WEBPACK FOOTER //
// ./src/redux/ducks/teacherPerceptions.ts